export class ApiError extends Error {
  constructor(public status: number, message: string) {
    super(message);
  }
}

async function request<T>(path: string, init: RequestInit = {}): Promise<T> {
  const headers = new Headers(init.headers);
  if (init.body && !(init.body instanceof FormData) && !(init.body instanceof ReadableStream)) {
    headers.set("content-type", "application/json");
  }
  const res = await fetch(path, { ...init, headers, credentials: "same-origin" });
  const text = await res.text();
  let payload: unknown = null;
  if (text) {
    try { payload = JSON.parse(text); } catch { payload = text; }
  }
  if (!res.ok) {
    const msg = (payload && typeof payload === "object" && "error" in payload)
      ? String((payload as any).error)
      : `request failed (${res.status})`;
    throw new ApiError(res.status, msg);
  }
  return payload as T;
}

export const api = {
  get: <T>(p: string) => request<T>(p),
  post: <T>(p: string, body?: unknown) =>
    request<T>(p, { method: "POST", body: body == null ? undefined : JSON.stringify(body) }),
  patch: <T>(p: string, body?: unknown) =>
    request<T>(p, { method: "PATCH", body: body == null ? undefined : JSON.stringify(body) }),
  del: <T>(p: string) => request<T>(p, { method: "DELETE" }),
  upload: async (
    file: File,
    opts: { kind: string; jobId?: string | null },
  ): Promise<{ id: string; url: string; filename: string; mime: string; sizeBytes: number }> => {
    const qs = new URLSearchParams({
      kind: opts.kind,
      filename: file.name,
    });
    if (opts.jobId) qs.set("jobId", opts.jobId);
    const res = await fetch(`/api/assets?${qs}`, {
      method: "POST",
      credentials: "same-origin",
      headers: { "content-type": file.type || "application/octet-stream" },
      body: file,
    });
    const text = await res.text();
    const payload = text ? JSON.parse(text) : null;
    if (!res.ok) throw new ApiError(res.status, payload?.error ?? "upload failed");
    return payload;
  },
};
